import 'prismjs/themes/prism-solarizedlight.css'

import { MDXProvider } from '@mdx-js/react'
import { lighten } from 'polished'
import Highlight, { defaultProps } from 'prism-react-renderer'
import * as React from 'react'
import styled from 'styled-components'

import { getLanguage } from '../../utils/getLanguage'
import { Consumer } from '../routes/public/Lecture'
import { ZipViewer } from './ZipViewer'

const StyledMarkdown = styled.div`
  ${({ theme }) => `
    p {
      font-size: 18px;
      padding: ${theme['padding-small']};
      line-height: 34px;

    }
    strong {
      font-size: 24px;
    }
    code {
      background-color: ${lighten(0.4, theme.title)};
      padding: 4px;
      border-radius: 4.8px;
    }
    a {
      text-decoration: underline;
    }

    padding-top: ${theme['padding-small']};
    padding-bottom: ${theme['padding-small']};
    .objective{
      padding: 0px;
      margin: 0px;
      p{
        font-size: 20px;
        span{
          font-weight: bold;
        }
      }
    }
  `}
`

const StyledCodeBlock = styled.div`
  ${({ theme, className }) => {
    return `
      h4 {
       background-color: ${lighten(0.4, theme.title)};
       text-align: left;
       padding: ${theme['padding-small']};
       margin-bottom: 0px;
      }
      .prism-code {
        margin-top: 0px;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
      }
  `
  }}
`

const pre = props => {
  const { children } = props.children.props
  const { className } = props.children.props
  const stringifiedClassName = className
    ? className.replace('language-', '')
    : ' '

  return (
    <StyledCodeBlock className={props.children.props.className}>
      <h4>{stringifiedClassName}</h4>
      <Highlight
        {...defaultProps}
        code={children}
        // @ts-ignore
        language={getLanguage(stringifiedClassName)}
      >
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <pre className={className} style={style}>
            {tokens.map((line, i) => (
              <div {...getLineProps({ line, key: i })}>
                {line.map((token, key) => (
                  <span {...getTokenProps({ token, key })} />
                ))}
              </div>
            ))}
          </pre>
        )}
      </Highlight>
    </StyledCodeBlock>
  )
}

const shortcodes = { ZipViewer, pre }

const Markdown = () => {
  return (
    <Consumer>
      {({ children }) => {
        return (
          <StyledMarkdown>
            <MDXProvider components={shortcodes}>{children}</MDXProvider>
          </StyledMarkdown>
        )
      }}
    </Consumer>
  )
}

export default Markdown
